import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
  ArrowRight,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleFooterNavigation = (path?: string, section?: string) => {
    if (!path) return;

    navigate(path);

    if (section) {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const company = [
    { title: "Testimonials", path: "/case-studies", section: "testimonials" },
    { title: "Our Team", path: "/about", section: "leadership" },
    { title: "Case Studies", path: "/case-studies" },
    { title: "Trusted Partners", path: "/", section: "trusted-clients" },
    { title: "Contact", path: "/contact" },
  ];

  // const services = [
  //   { title: "Custom Software Development", href: "/services/custom-software" },
  //   { title: "Mobile App Development", href: "/services/mobile-development" },
  //   { title: "Web Development", href: "/services/web-development" },
  //   { title: "Cloud Migration", href: "/services/cloud-migration" },
  //   { title: "AI/ML Solutions", href: "/services/ai-ml" },
  //   { title: "DevOps Services", href: "/services/devops" },
  //   { title: "Quality Assurance", href: "/services/testing" },
  // ];

  const solutions = [
    { title: "Solar Monitoring Platform", href: "/solutions/solar" },
    { title: "Industrial IoT / Wind Integration", href: "/solutions/wind" },
    { title: "Multi-vendor Motor Synchronization", href: "/solutions/motor" },
    { title: "BFSI Microservices Modernization", href: "/solutions/bfsi" },
    { title: "EdTech Child-Safe Talent Platform", href: "/solutions/edtech" },
  ];

  const industries = [
    { title: "Healthcare", href: "/industries/healthcare" },
    { title: "FinTech & BFSI", href: "/industries/fintech" },
    { title: "E-commerce & Retail", href: "/industries/commerce" },
    // { title: "Real Estate", href: "/industries/real-estate" },
    {
      title: "Energy & Utilities Solutions",
      href: "/industries/energyUtilities",
    },
    { title: "Manufacturing & Automotive", href: "/industries/industrial" },
    { title: "Education", href: "/industries/education" },
    { title: "Logistics", href: "/industries/logistics" },
    { title: "Entertainment", href: "/industries/entertainment" },
  ];

  const Products = [
    { title: "Payroll", href: "/products/Payroll" },
    { title: "Communication Tool", href: "/products/communicationTool" },
    { title: "Modern Hiring", href: "/products/ModernHiring" },
  ];

  return (
    <footer className="smartborn-footer bg-gradient-to-r from-slate-900 to-slate-800 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 sm:gap-8 md:gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/lovable-uploads/191658a8-ce44-4edc-a729-a8d8b92a2d8b.png"
                alt="Smartborn - Leading IT Services Company Logo"
                className="h-12 w-auto bg-white/70 backdrop-blur-sm rounded-lg px-4 py-3 hover:bg-white transition-all duration-300 shadow-lg"
                width="150"
                height="48"
              />
            </Link>
            <p className="text-body text-white/70 mb-6 leading-relaxed">
              Smartborn is a global leader in transformative technology
              solutions, serving businesses, governments, and organizations
              worldwide since 2017. With over 200 professionals and 8 years of
              proven experience, our focus on digital excellence, operational
              efficiency, and revenue growth drives us to deliver tangible value
              swiftly and at scale.
            </p>

            {/* Partnerships */}
            <div className="mb-6">
              <h4 className="text-h5 mb-3 text-white">Trusted Partnerships</h4>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-primary shadow-glow rounded-full"></div>
                  <span className="text-body-sm text-white/80">
                    SAP Partner Open Ecosystem
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-secondary shadow-glow-secondary rounded-full"></div>
                  <span className="text-body-sm text-white/80">
                    AWS Partner Network
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-primary" />
                <span className="text-body-sm text-white/80">
                  +91 98869 28201
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-secondary shadow-glow-secondary" />
                <span className="text-body-sm text-white/80">
                  contact@smartborn.io
                </span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-primary shadow-glow mt-0.5" />
                <span className="text-body-sm text-white/80">
                  PID No-14, new, 49, 2nd floor ,VLVC Plaza, 39-49, 19th Main
                  Rd, 1st Block, Rajajinagar, Bengaluru, Karnataka 560010
                </span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-4">
              {/* <a
                href="#"
                className="bg-white/10 hover:bg-primary transition-colors duration-300 p-3 rounded-lg"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a> */}
              {/* <a
                href="#"
                className="bg-white/10 hover:bg-primary transition-colors duration-300 p-3 rounded-lg"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a> */}
              <a
                href="https://in.linkedin.com/company/smartborn"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-secondary transition-colors duration-300 p-3 rounded-lg"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                className="bg-white/10 hover:bg-primary transition-colors duration-300 p-3 rounded-lg"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a> */}
              {/* <a
                href="#"
                className="bg-white/10 hover:bg-primary transition-colors duration-300 p-3 rounded-lg"
                aria-label="YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a> */}
            </div>
          </div>

          {/* Services */}
          {/* <div>
            <h4 className="text-h5 font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.href}
                    className="footer-link"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Solutions */}
          <div>
            <h4 className="text-h5 font-semibold mb-6">Solutions</h4>
            <ul className="space-y-3">
              {solutions.map((solutions, index) => (
                <li key={index}>
                  <Link
                    to={solutions.href}
                    className="footer-link text-white/70 hover:text-primary"
                  >
                    {solutions.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-h5 font-semibold mb-6">Industries</h4>
            <ul className="space-y-3">
              {industries.map((industry, index) => (
                <li key={index}>
                  <Link
                    to={industry.href}
                    className="footer-link text-white/70 hover:text-primary"
                  >
                    {industry.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-h5 font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              {company.map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      handleFooterNavigation(item.path, item.section)
                    }
                    className="footer-link text-white/70 hover:text-primary"
                  >
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-h5 font-semibold mb-6">Products</h4>
            <ul className="space-y-3">
              {Products.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.href}
                    className="footer-link text-white/70 hover:text-primary"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="text-body-sm text-white/60">
                © 2026 Smartborn. All rights reserved.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-6 text-sm"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
